export const SecondaryCard = (props) => {
  return (
    <div>
      <button
        type="submit"
        className="text-sm flex justify-center py-1 px-2 border border-transparent rounded-full font-semibold text-tdark tracking-tight bg-purpleLight transition duration-300 hover:bg-purple hover:text-white focus:outline-none"
      >
        <div className="flex">
          {props.text}
          <div className="">{props.icon}</div>
        </div>
      </button>
    </div>
  );
};
